export default __webpack_public_path__ + "static/media/face_2_27.3042eaf9.png";